import Autocomplete from '@mui/material/Autocomplete';
import Box, { BoxProps } from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

type AutocompleteOption = {
  id: string | number;
  name: string;
};

type SingleSiteSelectionProps<T extends AutocompleteOption> = {
  value: T['id'] | null;
  onChange: (value: T['id'] | null) => void;
  options: T[];
  error?: boolean;
  helperText?: string;
  label: string;
  containerSx?: BoxProps['sx'];
  autocompleteSx?: BoxProps['sx'];
};

const StyleAutocomplete = styled(Autocomplete)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    padding: '10px',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
})) as typeof Autocomplete;

export default function SingleSiteSelection<T extends AutocompleteOption>({
  value,
  onChange,
  options,
  error,
  helperText,
  label,
  containerSx,
  autocompleteSx,
}: SingleSiteSelectionProps<T>) {
  const selectedOption = options.find((item) => item.id === value) ?? null;
  return (
    <Box
      sx={containerSx}
    >
      <StyleAutocomplete<T, false, false, false>
        data-testid="mui-component-select-site"
        options={options}
        getOptionLabel={(option) => option.name}
        value={selectedOption}
        onChange={(_, option) => onChange(option?.id ?? null)}
        renderOption={(props, option: T) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
        sx={autocompleteSx}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            helperText={helperText}
            margin="normal"
            fullWidth
            label={label}
          />
        )}
      />
    </Box>
  );
}
